module.exports = __webpack_public_path__ + "img/TripCreator-demo.9c60c9ba.gif";